import PropTypes from 'prop-types';
import React from 'react';

export const GoogleIcon = ({ style, ...props }) => (
  <svg style={{ width: 24, height: 24, ...style }} viewBox="0 0 24 24" {...props}>
    <g fill="none" transform="translate(2 2)">
      <path
        fill="#4285F4"
        d="M19.9904687,10.1870992 C19.9904687,9.36770992 19.9224219,8.76977099 19.7751562,8.14969466 L10.1992188,8.14969466 L10.1992188,11.8480153 L15.8200781,11.8480153 C15.7067969,12.7670992 15.0948437,14.1512214 13.7349219,15.0812977 L13.7158594,15.2051145 L16.7435937,17.4969466 L16.9533594,17.5174046 C18.8798437,15.7789313 19.9904687,13.2210687 19.9904687,10.1870992"
      />
      <path
        fill="#34A853"
        d="M10.1992187,19.9312977 C12.9529687,19.9312977 15.2647656,19.0454198 16.9533594,17.5174046 L13.7349219,15.0812977 C12.8736719,15.6681679 11.7177344,16.0778626 10.1992187,16.0778626 C7.50210937,16.0778626 5.21296875,14.3394656 4.39695312,11.9366412 L4.27734375,11.9465649 L1.1290625,14.3272519 L1.08789063,14.439084 C2.76507812,17.6945038 6.21015625,19.9312977 10.1992187,19.9312977"
      />
      <path
        fill="#FBBC05"
        d="M4.39695312,11.9366412 C4.18164062,11.3165649 4.05703125,10.6521374 4.05703125,9.96564885 C4.05703125,9.27908397 4.18164062,8.61473282 4.385625,7.99465649 L4.37992187,7.86259542 L1.1921875,5.44366412 L1.08789062,5.4921374 C0.396640625,6.84305344 0,8.36007634 0,9.96564885 C0,11.5712214 0.396640625,13.0881679 1.08789062,14.439084 L4.39695312,11.9366412"
      />
      <path
        fill="#EB4335"
        d="M10.1992187,3.85335878 C12.114375,3.85335878 13.40625,4.66167939 14.1428906,5.33717557 L17.0213281,2.5910687 C15.2535156,0.985496183 12.9529687,0 10.1992187,0 C6.21015625,0 2.76507812,2.23671756 1.08789062,5.4921374 L4.385625,7.99465649 C5.21296875,5.59183206 7.50210937,3.85335878 10.1992187,3.85335878"
      />
    </g>
  </svg>
);
GoogleIcon.propTypes = {
  style: PropTypes.shape({}),
};
GoogleIcon.defaultProps = {
  style: null,
};
